import Vue from 'vue'
import Router from 'vue-router'
import routes from './router/routes'

Vue.use(Router)

const originalReplace = Router.prototype.push;
Router.prototype.push = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const RouterVue = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push (to) {
//     return VueRouterPush.call(this, to).catch(err => err)
// }

// 路由前置守卫 （判断用户是否登录）
RouterVue.beforeEach((to, from, next) => {
	// 设置title
	// if (to.meta.title) {
    // document.title = '东方';
	// 	sessionStorage.setItem('page-title', to.meta.title);
 //  }
    // next();
	const noCheckLogin = ['Login'];
	(sessionStorage.getItem('token') || noCheckLogin.includes(to.name)) ?
		next() :
		next({ path: '/login', replace: true });
})

// 路由后置守卫 （页面加载完成后，想做点什么）
RouterVue.afterEach((to, from) => {

})

// 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面
RouterVue.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default RouterVue
